import { atom, selector } from 'recoil';
import { AvailableCommand } from '../types/availableCommand';

export const availableCommandsState = atom<AvailableCommand[] | undefined>({
  key: 'app.commands.available',
  default: undefined,
});

export const availableCommandLabelsState = selector<{ [key: string]: string } | undefined>({
  key: 'app.commands.labels',
  get: ({ get }) => {
    const commands = get(availableCommandsState);
    if (!commands || !commands.length) return;
    const commandLabels: { [key: string]: string } = {};
    commands.forEach((command) => {
      commandLabels[command.commandName] = command.commandDescription;
    });
    return commandLabels;
  },
});

export const selectedCommandState = atom<AvailableCommand | undefined>({
  key: 'app.commands.selected',
  default: undefined,
});

export const commandFieldsState = selector({
  key: 'app.commands.fields',
  get: ({ get }) => {
    const selectedCommand = get(selectedCommandState);
    if (!selectedCommand?.fields)
      return [];

    return Object.entries(selectedCommand.fields).map(([key, field]) => {
      return {
        ...field,
        key,
      }
    });
  },
});
